export default "__VITE_ASSET__B4kUZ9pD__"